import type { WorkflowValidationRequest } from '../services/workflow';
import { getPlainTextFromHtml, isRichTextMeaningful } from './richText';

export const DIRECT_RESOLUTION_MIN_NOTE_LENGTH = 20;

export interface DirectResolutionErrors {
  note?: string;
  evidenceUrl?: string;
}

export type DirectResolutionVisibilityScope = 'unit' | 'warek';

export const normalizeEvidenceUrl = (value?: string): string => (value || '').trim();

export const isEvidenceUrlValid = (value?: string): boolean => {
  const normalized = normalizeEvidenceUrl(value);

  if (!normalized) {
    return false;
  }

  try {
    const url = new URL(normalized);
    return ['http:', 'https:'].includes(url.protocol);
  } catch {
    return false;
  }
};

export const validateDirectResolutionFields = (
  noteHtml: string,
  evidenceUrl: string
): DirectResolutionErrors => {
  const errors: DirectResolutionErrors = {};

  if (!isRichTextMeaningful(noteHtml, DIRECT_RESOLUTION_MIN_NOTE_LENGTH)) {
    errors.note = `Catatan penanganan minimal ${DIRECT_RESOLUTION_MIN_NOTE_LENGTH} karakter agar keputusan tindak lanjut jelas.`;
  }

  if (!normalizeEvidenceUrl(evidenceUrl)) {
    errors.evidenceUrl = 'Tautan bukti dokumen wajib diisi.';
  } else if (!isEvidenceUrlValid(evidenceUrl)) {
    errors.evidenceUrl = 'Masukkan tautan http/https yang valid.';
  }

  return errors;
};

export const buildDirectResolutionPayload = (
  noteHtml: string,
  evidenceUrl: string
): WorkflowValidationRequest => ({
  feedback: getPlainTextFromHtml(noteHtml),
  resolution_note_html: noteHtml,
  resolution_evidence_url: normalizeEvidenceUrl(evidenceUrl),
});

export const getDirectResolutionVisibilityHint = (
  scope: DirectResolutionVisibilityScope = 'unit'
): string => (
  scope === 'warek'
    ? 'Catatan penanganan dan tautan bukti akan tampil di detail laporan dan dapat dipantau oleh Rektor serta Administrator.'
    : 'Catatan penanganan dan tautan bukti akan tampil di detail laporan dan dapat dipantau oleh Wakil Rektor terkait, Rektor, serta Administrator.'
);
